/**
=========================================================
* Material Dashboard 2 PRO React TS - v1.0.1
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-2-pro-react-ts
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/
import './styles.css'
import { PricePlan } from "types";
// react-router-dom components
import { Link, useNavigate } from "react-router-dom";

// @mui material components
import Card from "@mui/material/Card";
import Checkbox from "@mui/material/Checkbox";

// Material Dashboard 2 PRO React TS components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";
import validator from "validator";

// Authentication layout components
import CoverLayout from "layouts/authentication/components/CoverLayout";

// Images
import bgImage from "assets/images/bg-sign-up-cover.jpeg";
import { useEffect, useRef, useState } from "react";
import { Auth } from "aws-amplify";
import { Box, Modal, Typography } from "@mui/material";
import { finalizeSignUp, sendContactInquiry } from "services/user-services";
import { useAppContext } from "context/app-context";
import { createSubscription, deletePendingSubscription, getSubscriptionSession, prepareSubscription, validateCoupon } from "services/reepay-services";
import Loader from "components/Loader";
import { subscribeNewsLetter } from "services/sendpulse-service";
import { Vertify } from "@alex_xu/react-slider-vertify";



declare const Reepay: any

function Cover(): JSX.Element {
  const navigate = useNavigate()

  const [email, setEmail] = useState<string>('')
  const [password, setPassword] = useState<string>('')
  const [confirmPassword, setConfirmPassword] = useState<string>('')
  const [name, setName] = useState<string>('')
  const [schoolName, setSchoolName] = useState<string>('')
  const [eanNumber, setEanNumber] = useState<string>('')
  const [message, setMessage] = useState('')
  const [schoolAddress, setSchoolAddress] = useState('')
  const [phoneNumber, setPhoneNumber] = useState('')
  const [sessionId, setSessionId] = useState<string>('')
  const [pricePlan] = useState<PricePlan>('1year')
  const [subscriptionId, setSubscriptionId] = useState<string>()
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const [captcha, setCaptcha] = useState(false)
  const [subId, setSubId] = useState<string>('')
  const [role, setRole] = useState<string>('TEACHER')
  const [checkedTAC, setCheckedTAC] = useState(false)
  const [subscribeNewsletter, setSubscribeNewsletter] = useState(false)
  const [coupon, setCoupon] = useState('')

  const { handleMessage } = useAppContext()


  // const handleSignUp = async () => {
  //   let hasErrors = false
  //   setIsLoading(true)
  //   if (coupon?.length) {
  //     if (!(await validateCoupon(coupon)).isValid) {
  //       handleMessage('Kuponen er ikke gyldig', 'error')
  //       hasErrors = true
  //     }
  //   }
  //   if (!validator.isStrongPassword(password, {
  //     minLength: 6, minLowercase: 0, minSymbols: 0, minUppercase: 0, minNumbers: 0
  //   })) {
  //     handleMessage('Adgangskoden skal være på mindst 6 tegn', 'error')
  //     hasErrors = true
  //   }
  //   if (password !== confirmPassword) {
  //     handleMessage('Kodeordene er ikke ens', 'error')
  //     hasErrors = true
  //   }
  //   if (validator.isEmpty(name)) {
  //     handleMessage('Hvad hedder du?', 'error')
  //     hasErrors = true
  //   }
  //   if (!validator.isEmail(email)) {
  //     handleMessage('Hvad er din email?', 'error')
  //     hasErrors = true
  //   }
  //   if (validator.isEmpty(role)) {
  //     handleMessage('Er du lærer eller studerende?', 'error')
  //     hasErrors = true
  //   }
  //   if (hasErrors) {
  //     setIsLoading(false)
  //     return
  //   }
  //   const user = await (async () => {
  //     try {
  //       const auth = await Auth.signUp({
  //         username: email,
  //         password,
  //         attributes: {
  //           email,
  //           name,
  //           'custom:role': role,
  //         }
  //       })
  //       if (subscribeNewsletter) {
  //         await subscribeNewsLetter(email)
  //       }
  //       return auth
  //     } catch (error) {
  //       //@ts-ignore
  //       handleMessage(error?.response?.data?.message || error?.message, 'error')
  //       return
  //     } finally {
  //       setIsLoading(false)
  //     }


  //   })()
  //   console.log(user)

  //   setSubId(user?.userSub)

  //   if (user) {
  //     setOpen(!open)
  //   } else {
  //     handleMessage('Kunne ikke oprette en konto.', 'error')
  //   }
  // }

  const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
  };
  // const { setUser, setUserToken } = useAppContext()
  // const [open, setOpen] = useState<boolean>(false)
  // const [confirmationCode, setConfirmationCode] = useState<string>('')
  // const [methodPayment, setMethodPayment] = useState('')

  const rpModalRef = useRef(null)

  useEffect(() => {
    if (sessionId) {
      rpModalRef.current = new Reepay.WindowSubscription(sessionId)
      addReepayEventHandlers()
    }
  }, [sessionId])
  const handleSuccessPayment = async () => {
    await Auth.signOut()
  }

  const handleErrorPayment = () => {
  }

  const handleCancelPayment = async () => {
    if (subscriptionId) {
      setSubscriptionId(undefined)

      try {
        await deletePendingSubscription(subscriptionId)
      } catch (error: any) {
        if (error.status !== 404) {
          throw error
        } else {
          return
        }
      }

      await Auth.signOut()
    }
  }

  const handleClosePayment = async () => {
    await handleCancelPayment()
  }


  const addReepayEventHandlers = () => {
    if (!rpModalRef.current) {
      return
    }

    rpModalRef.current.addEventHandler(Reepay.Event.Accept, handleSuccessPayment)
    rpModalRef.current.addEventHandler(Reepay.Event.Error, handleErrorPayment)
    rpModalRef.current.addEventHandler(Reepay.Event.Cancel, handleCancelPayment)
    rpModalRef.current.addEventHandler(Reepay.Event.Close, handleClosePayment)
  }

  // const handleConfirmCode = async () => {
  //   try {
  //     setIsLoading(true)
  //     await Auth.confirmSignUp(email, confirmationCode)
  //     setOpen(!open)
  //     const token = await Auth.signIn(email, password)
  //     setUserToken(
  //       token
  //     )
  //     let reepayResult
  //     if (coupon) {
  //       const v = await validateCoupon(coupon)
  //       if (!v.isValid) {
  //         handleMessage('Kuponen er ikke gyldig.', 'error')
  //         return
  //       }
  //       reepayResult = await createSubscription(token.attributes.sub, email,
  //         name, pricePlan, [coupon])

  //       navigate('/profile/profile-overview')
  //     } else {
  //       reepayResult = await prepareSubscription(token.attributes.sub, email,
  //         name, pricePlan, [])
  //       const subscriptionSessionId = await getSubscriptionSession(reepayResult.handle)
  //       if (subscriptionSessionId) {
  //         setSessionId(subscriptionSessionId.id)
  //       }
  //     }
  //     console.log({ subId })
  //     setUser(
  //       await finalizeSignUp(subId, { name, email, role, subscriptionId: reepayResult.handle })
  //     )

  //   } catch (error) {
  //     //@ts-ignore
  //     handleMessage(error?.response?.data?.message || error.message, 'error')
  //   } finally {
  //     setIsLoading(false)
  //   }
  // }

  // const handleResendVerificationCode = async () => {
  //   try {
  //     await Auth.resendSignUp(email)
  //     handleMessage('Ny bekræftelseskode er sendt til din email', 'success')
  //   } catch (error) {
  //     //@ts-ignore
  //     handleMessage(error?.response?.data?.message || error.message, 'error')
  //   }
  // }

  const handleContactInquiry = async () => {
    if (!captcha){
      handleMessage('Du skal udfylde captcha', 'error')
      return
    }
    if (!validator.isEmail(email)) {
      handleMessage('Du skal udfylde en gyldig email', 'error')
      return
    }
    if (!validator.isLength(name, { min: 2 })) {
      handleMessage('Du skal udfylde et gyldigt navn', 'error')
      return
    }
    if (!validator.isLength(message, { min: 2 })) {
      handleMessage('Du skal udfylde en besked', 'error')
      return
    }
    if (!validator.isLength(schoolName, { min: 2 })) {
      handleMessage('Du skal udfylde et skolenavn', 'error')
      return
    }
    if (!validator.isLength(eanNumber, { min: 13 })) {
      handleMessage('Du skal udfylde et gyldigt EAN nummer', 'error')
      return
    }
    if (!validator.isLength(phoneNumber, { min: 8 })) {
      handleMessage('Du skal udfylde et gyldigt telefonnummer', 'error')
      return
    }
    if (!validator.isLength(schoolAddress, { min: 2 })) {
      handleMessage('Du skal udfylde en skoleadresse', 'error')
      return
    }
        
    try {
      await sendContactInquiry(name, email, message, schoolName, eanNumber, schoolAddress, phoneNumber)
      handleMessage('Din besked er sendt', 'success')
    } catch (error) {
      handleMessage('Der skete en fejl', 'error')
    }
  }

  return (
    <CoverLayout image={bgImage}>
      {isLoading && <Loader />}
      {/* <Modal
        open={open}
        onClose={() => setOpen(!open)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Typography id="modal-modal-title" variant="h6" component="h2">
            Indsæt bekræftelseskode
          </Typography>
          <MDBox pr={1} mt={2.5}>
            <MDInput fullWidth value={confirmationCode} onChange={(e: any) => setConfirmationCode(e.target.value)} label="Bekræftelseskode" />
          </MDBox>
          <MDBox pr={1} mt={2.5} justifyContent='space-between' display='flex'>
            <MDButton onClick={handleConfirmCode} color='success' >
              Tilføj
            </MDButton>
            <MDButton onClick={handleResendVerificationCode} color='info' >
              Send igen
            </MDButton>
          </MDBox>
        </Box>
      </Modal> */}
      <Card>
        <MDBox
          variant="gradient"
          bgColor="info"
          borderRadius="lg"
          coloredShadow="success"
          mx={2}
          mt={-8}
          p={3}
          mb={1}
          textAlign="center"
        >
          <MDTypography variant="h4" fontWeight="medium" color="white" mt={1}>
            Quiz med os allerede i dag
          </MDTypography>
          <MDTypography display="block" variant="button" color="white" my={1}>
            Skriv din email og kodeord for at oprette
          </MDTypography>
        </MDBox>
        <MDBox pt={4} pb={3} px={3}>
          {/* <div style={{ textAlign: 'center' }}>
            <ButtonGroup variant="contained" aria-label="outlined primary button group">
              <MDButton onClick={() => setMethodPayment('card')} color={methodPayment === 'card' ? "secondary" : 'light'}>Betal med kort</MDButton>
              <MDButton onClick={() => setMethodPayment('epn')} color={methodPayment === 'epn' ? "secondary" : 'light'}>Få adgang via EAN</MDButton>
            </ButtonGroup>
          </div> */}
          <MDBox component="form" role="form">
            <>
              <MDBox mb={2}>
                <MDInput type="text" label="Fornavn og efternavn" value={name} onChange={(e: React.ChangeEvent<HTMLInputElement>) => setName(e.target.value)} variant="standard" fullWidth />
              </MDBox>
              <MDBox mb={2}>
                <MDInput type="email" label="E-mail" value={email} onChange={(e: React.ChangeEvent<HTMLInputElement>) => setEmail(e.target.value)} variant="standard" fullWidth />
              </MDBox>
              <MDBox mb={2}>
                <MDInput type="text" label="Navn på skole" value={schoolName} onChange={(e: React.ChangeEvent<HTMLInputElement>) => setSchoolName(e.target.value)} variant="standard" fullWidth />
              </MDBox>
              <MDBox mb={2}>
                <MDInput type="text" label="Skolens adresse" value={schoolAddress} onChange={(e: React.ChangeEvent<HTMLInputElement>) => setSchoolAddress(e.target.value)} variant="standard" fullWidth />
              </MDBox>
              <MDBox mb={2}>
                <MDInput type="text" label="EAN nummer" value={eanNumber} onChange={(e: React.ChangeEvent<HTMLInputElement>) => setEanNumber(e.target.value)} variant="standard" fullWidth />
              </MDBox>
              <MDBox mb={2}>
                <MDInput type="text" label="Telefonnummer" value={phoneNumber} onChange={(e: React.ChangeEvent<HTMLInputElement>) => setPhoneNumber(e.target.value)} variant="standard" fullWidth />
              </MDBox>
              <MDBox mb={2}>
                <MDInput type="text" label='Kommentar og evt. bestilling af ekstra brætspil' value={message} rows={5} onChange={(e: React.ChangeEvent<HTMLTextAreaElement>) => setMessage(e.target.value)} multiline variant="standard" fullWidth />
              </MDBox>
              <MDBox mb={2}>
              <Vertify
                width={320}
                height={160}
                visible={true}
                onSuccess={() => setCaptcha(true)}
                onRefresh={() => setCaptcha(false)}
                onFail={() => handleMessage('Du skal udfylde captcha', 'error')}
              />
              </MDBox>


              <MDButton variant="gradient" color="info" fullWidth onClick={() => handleContactInquiry()}>
                Bestil
              </MDButton>
            </>
            <MDBox mt={3} mb={1} textAlign="center">
              <MDTypography variant="button" color="text">
                Har du adgang?{" "}
                <MDTypography
                  component={Link}
                  to="/authentication/sign-in"
                  variant="button"
                  color="info"
                  fontWeight="medium"
                  textGradient
                >
                  Login her
                </MDTypography>
              </MDTypography>
            </MDBox>
            <MDBox mt={0} mb={0} textAlign="center">
              <MDTypography variant="button" color="text">
                Geeksters bruger?{" "}
                <MDTypography
                  component={Link}
                  to="/authentication/geekster-sign-up"
                  variant="button"
                  color="info"
                  fontWeight="medium"
                  textGradient
                >
                  Klik her
                </MDTypography>
              </MDTypography>
            </MDBox>
          </MDBox>
        </MDBox>
      </Card>
    </CoverLayout >
  );
}

export default Cover;
